"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgPencil01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.707 2.293a3.829 3.829 0 0 0-5.414 0L4.976 13.609c-.233.234-.41.41-.565.61a4 4 0 0 0-.364.56c-.12.223-.209.456-.327.764l-2.153 5.598a1 1 0 0 0 1.292 1.292l5.38-2.069.093-.036.125-.048c.308-.118.541-.208.764-.327.196-.106.384-.228.56-.364.2-.155.376-.332.61-.566L21.707 7.707a3.828 3.828 0 0 0 0-5.414ZM5.381 16.795l-1.14 2.964 2.964-1.14-1.824-1.824Z", fill: "currentColor" }) }))); };
exports.default = SvgPencil01;
